import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useNotification } from "app/NotificationProvider";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { StyledInputContainer } from "features/StyledInputContainer";
import {
  selectCurrentFarm,
  updateYieldEvent,
  useAppDispatch,
  useAppSelector,
  YieldEvent,
} from "model";
import { Dispatch, SetStateAction } from "react";
import EnterYieldEvent from "./EnterYieldEvent";

export default function UpdateYieldEvent({
  yieldEvent,
  dialogOpen,
  setDialogOpen,
}: {
  yieldEvent: YieldEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const dispatch = useAppDispatch();
  const { notify } = useNotification();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setDialogOpen(false);
    mixpanel.track("Update yield event cancelled");
  };

  const currentFarm = useAppSelector(selectCurrentFarm);

  async function handleSave(yieldEvent: YieldEvent) {
    await dispatch(
      updateYieldEvent({
        yieldEvent,
        farmGuid: currentFarm?.guid ?? "",
      })
    );
    notify(t("addYieldEvent.add.success"));
    mixpanel.track("YieldEvent created");
    handleClose();
  }
  return (
    <Dialog
      fullScreen={isMobile}
      maxWidth="md"
      disableEscapeKeyDown
      open={dialogOpen}
      onClose={handleClose}
    >
      <StyledInputContainer isMobile={isMobile}>
        <EnterYieldEvent
          yieldEvent={yieldEvent}
          handleSave={handleSave}
          handleClose={() => {
            handleClose();
          }}
        />
      </StyledInputContainer>
    </Dialog>
  );
}
